import { render } from "./RunInfo.vue?vue&type=template&id=c23288c4"
import script from "./RunInfo.vue?vue&type=script&lang=js"
export * from "./RunInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__